import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { throwIfAlreadyLoaded } from './module-import-guard';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';

import { DutchDateAdapter, DutchDatetimeAdapter, MG_DATETIME_ADAPTER } from '@mango/core';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'nl-NL' },
        { provide: DateAdapter, useClass: DutchDateAdapter },
        // Mango datetime pickers in this app all hold a date and a time
        { provide: MG_DATETIME_ADAPTER, useClass: DutchDatetimeAdapter },
    ],
    declarations: []
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}
